import { downloadCSV } from '@helpers/downloadCSV';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import type { FindAllSsoProvidersResponseDto } from 'app/API';

const headers = ['ID', 'Domains', 'Emails', 'Cognito Identity Provider', 'Type', 'Organization ID', 'Created'];

type TSsoProviderCsvData = Pick<
  FindAllSsoProvidersResponseDto['data'][number],
  'id' | 'domains' | 'emails' | 'identityProvider' | 'type' | 'organizationId' | 'createdAt'
>;

export const downloadSsoProvidersCsv = (ssoProviders: TSsoProviderCsvData[]) => {
  const array = ssoProviders.map((data) => {
    return {
      id: data.id,
      domains: data.domains.join(' '),
      emails: data.emails.join(' '),
      cip: data.identityProvider,
      type: data.type,
      organizationId: data.organizationId ?? '',
      created: getAmericanTime(data.createdAt),
    };
  });
  return downloadCSV(array, headers);
};
